import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <span className="logo-dhadee">Dhadee</span>
            <span className="logo-boutique">Boutique</span>
          </div>
          <p className="footer-tagline">Timeless Elegance, Modern Grace</p>
          <div className="footer-social">
            <a href="#!" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
              </svg>
            </a>
            <a href="#!" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
              </svg>
            </a>
            <a href="#!" aria-label="Pinterest">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 2C6.48 2 2 6.48 2 12c0 4.24 2.65 7.86 6.39 9.29-.09-.78-.17-1.98.03-2.82.19-.77 1.26-5.33 1.26-5.33s-.32-.64-.32-1.59c0-1.49.87-2.6 1.94-2.6.92 0 1.36.69 1.36 1.51 0 .92-.59 2.3-.89 3.58-.25 1.07.53 1.94 1.58 1.94 1.9 0 3.19-2.44 3.19-5.32 0-2.19-1.46-3.82-4.1-3.82-2.99 0-4.85 2.23-4.85 4.72 0 .85.25 1.45.64 1.91.18.21.2.3.14.54-.05.17-.15.59-.2.76-.06.24-.25.33-.46.24-1.3-.53-1.9-1.96-1.9-3.56 0-2.8 2.34-6.19 7-6.19 3.76 0 6.24 2.73 6.24 5.66 0 3.88-2.15 6.79-5.29 6.79-1.06 0-2.06-.57-2.4-1.22l-.65 2.54c-.22.83-.7 1.87-1.13 2.59.85.26 1.75.4 2.69.4 5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h4>Shop</h4>
          <ul>
            <li><Link to="/collections">All Collections</Link></li>
            <li><Link to="/collections">Bridal Wear</Link></li>
            <li><Link to="/collections">Sarees</Link></li>
            <li><Link to="/collections">Festive Wear</Link></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Info</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><a href="#!">Size Guide</a></li>
            <li><a href="#!">Care Instructions</a></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Visit Us</h4>
          <ul>
            <li>Dhadee Boutique</li>
            <li>Main Bazaar Road</li>
            <li>Nagercoil, Tamil Nadu</li>
            <li>+91 98765 43210</li>
            <li>dhadee@boutique.com</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 Dhadee Boutique. All Rights Reserved.</p>
        <div className="footer-pay">
          <span>Visa</span><span>Mastercard</span><span>UPI</span><span>PhonePe</span>
        </div>
      </div>
    </footer>
  );
}
